import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import { getErrorAsList } from "../utils";

const initialState = {
  loading: false,
  error: undefined,
  seniorityList: [],
};

export const getAllSeniorities = createAsyncThunk("seniorities/getAllSeniorities", async (args, thunkAPI) => {
  try {
    const { data } = await api.get("/api/seniorities/");
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const senioritySlice = createSlice({
  name: "seniority",
  initialState,
  extraReducers: {
    // Get all
    [getAllSeniorities.pending]: (state) => {
      state.loading = true;
    },
    [getAllSeniorities.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.seniorityList = action.payload;
    },
    [getAllSeniorities.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default senioritySlice.reducer;
